import React from 'react';

export default function IncomeStatementReport() {
  return <div>IncomeStatementReport</div>;
}
